goog.provide('el8.ptdata.model.med.fulfillmentMgr');

goog.require('el8.ptdata.model.med.fulfillment');

el8.ptdata.model.med.fulfillmentMgr = function() {
    // We need the whole list of fulfillments for rendering purposes.
    // Always assume that the first fulfillment is the latest fulfillment
    this._fulfillments = [];
};
el8.ptdata.model.med.fulfillmentMgr.prototype.loadFulfillments = function(specList) {
    this._fulfillments = specList.map(function(spec) {
        return el8.ptdata.model.med.fulfillment(spec);
    });
};
el8.ptdata.model.med.fulfillmentMgr.prototype.addFulfillment = function(spec) {
    var f = el8.ptdata.model.med.fulfillment(spec);
    this._fulfillments.unshift(f);
};
el8.ptdata.model.med.fulfillmentMgr.prototype.hasFulfillment = function() {
    return this._fulfillments.length && this._fulfillments[0].getState();
};
el8.ptdata.model.med.fulfillmentMgr.prototype.getAllFulfillments = function() {
    return this._fulfillments;
};
el8.ptdata.model.med.fulfillmentMgr.prototype.getLatestId = function() {
    return this._fulfillments.length ? this._fulfillments[0].getId() : null;
};
el8.ptdata.model.med.fulfillmentMgr.prototype.getLatestState = function() {
    return this._fulfillments.length ? this._fulfillments[0].getState() : null;
};
el8.ptdata.model.med.fulfillmentMgr.prototype.setLatestDismissed = function(arg) {
    if (this._fulfillments.length) {
        this._fulfillments[0].setDismissed(arg);
    }
};
el8.ptdata.model.med.fulfillmentMgr.prototype.isLatestDismissed = function(arg) {
    return this._fulfillments.length ? this._fulfillments[0].isDismissed() : null;
};
el8.ptdata.model.med.fulfillmentMgr.prototype.isLatestChanged = function() {
    var latestFulfillment = this._fulfillments.length ? this._fulfillments[0] : null
    return latestFulfillment ? latestFulfillment.getType() === 'surescripts_change' && latestFulfillment.isSuccess() : false;
};
el8.ptdata.model.med.fulfillmentMgr.prototype.isLatestERxError = function() {
    var latestERx = this.getLatestERx();
    return Boolean(latestERx && latestERx.isError());
};
el8.ptdata.model.med.fulfillmentMgr.prototype.isLatestERxErrorRetriable = function() {
    var latestERx = this.getLatestERx();
    return Boolean(this.isLatestERxError() && latestERx.isRetriable());
};
el8.ptdata.model.med.fulfillmentMgr.prototype.isLatestERxPending = function() {
    return this._fulfillments.length && this._fulfillments[0].isERx() &&
        this._fulfillments[0].isPending();
};
el8.ptdata.model.med.fulfillmentMgr.prototype.isLatestERxSuccess = function() {
    return this._fulfillments.length && this._fulfillments[0].isERx() &&
        this._fulfillments[0].isSuccess();
};
/**
 * Returns the latest eRx fulfillment, or null if no eRx fulfillments exist.
 */
el8.ptdata.model.med.fulfillmentMgr.prototype.getLatestERx = function() {
    for (var i = 0; i < this._fulfillments.length; i++) {
        var fulfillment = this._fulfillments[i];
        if (fulfillment.isERx()) {
            return fulfillment;
        }
    }
    return null;
};

el8.ptdata.model.med.fulfillmentMgr.prototype.getCurrentCancel = function() {
    // the latest cancellation fulfillment, provided it's more recent than
    // any eRx ones.. so basically ignores paper, etc.
    for (var i=0; i<this._fulfillments.length; i++) {
        if (this._fulfillments[i].isCancel()) {
            return this._fulfillments[i];
        }
        else if (this._fulfillments[i].isERx()) {
            return null;
        }
    }
};

el8.ptdata.model.med.fulfillmentMgr.prototype.hasPaperFulfillment = function() {
    return this._fulfillments.some(function(fulfillment) {
        return ["paper", "paper_nonfillable"].includes(fulfillment.getType());
    });
};

/**
 * Deny means the pharmacy denied the cancelrx request from the prescriber
 *
 * @returns {bool}
 */
el8.ptdata.model.med.fulfillmentMgr.prototype.isLatestCancelDenied = function() {
    var currentCancel = this.getCurrentCancel();
    return currentCancel && currentCancel.isDenied();
};

/**
 * @returns {bool}
 */
el8.ptdata.model.med.fulfillmentMgr.prototype.isLatestCancelError = function() {
    var currentCancel = this.getCurrentCancel();
    return currentCancel && currentCancel.isError();
};

/**
 * @returns {null/el8.ptdata.model.med.fulfillment}
 */
el8.ptdata.model.med.fulfillmentMgr.prototype.getCurrentChange = function() {
    // the latest change fulfillment, provided it's more recent than
    // any eRx ones.. so basically ignores paper, etc.
    for (var i=0; i<this._fulfillments.length; i++) {
        if (this._fulfillments[i].isChange()) {
            return this._fulfillments[i];
        }
        else if (this._fulfillments[i].isERx()) {
            return null;
        }
    }
}

/**
 * @returns {bool}
 */
el8.ptdata.model.med.fulfillmentMgr.prototype.isLatestChangeDenied = function() {
    var currentChange = this.getCurrentChange();
    return Boolean(currentChange && currentChange.isChangeDenied());
}

/**
 * Requiring action means either the pharmacy denied the cancelrx request or we errored
 * when telling surescripts about the cancelrx
 *
 * @returns {bool}
 */
el8.ptdata.model.med.fulfillmentMgr.prototype.isLatestCancelRequiringAction = function() {
    return this.isLatestCancelDenied() || this.isLatestCancelError();
};

el8.ptdata.model.med.fulfillmentMgr.prototype.isLatestCancelSuccess = function() {
    var currentCancel = this.getCurrentCancel();
    return currentCancel && currentCancel.isSuccess();
};
el8.ptdata.model.med.fulfillmentMgr.prototype.isLatestCancelPending = function() {
    var currentCancel = this.getCurrentCancel();
    return currentCancel && currentCancel.isPending();
};
el8.ptdata.model.med.fulfillmentMgr.prototype.isLatestCancelSent = function() {
    var currentCancel = this.getCurrentCancel();
    return currentCancel && currentCancel.isSent();
};
el8.ptdata.model.med.fulfillmentMgr.prototype.isLatestCancelIgnored = function() {
    var currentCancel = this.getCurrentCancel();
    return currentCancel && currentCancel.isCancelIgnored()
};

el8.ptdata.model.med.fulfillmentMgr.prototype.getLatestPharmacy = function() {
    for (var i=0; i<this._fulfillments.length; i++) {
        if (this._fulfillments[i].getPharmacyNcpdpid()) {
            return this._fulfillments[i].getPharmacy();
        }
    }
    return null;
};
el8.ptdata.model.med.fulfillmentMgr.prototype.getLatestServiceLocationId = function() {
    if (this._fulfillments.length) {
        return this._fulfillments[0].getServiceLocationId();
    }
    return null;
};
el8.ptdata.model.med.fulfillmentMgr.prototype.getLatestExternalFulfillment = function() {
    for (var i=0; i<this._fulfillments.length; i++) {
        if (this._fulfillments[i].showOnChartFeed()) {
            return this._fulfillments[i];
        }
    }
    return null;
};
